module.exports = __webpack_public_path__ + "static/media/7.fda09cf1.jpg";